/** 라이더 상태 */
const attendCode = {
    /** 출근 */
    ON: {
        type: 'on',
        code: 'ON',
        text: 'common.on',
        color: '',
        textColor: '',
    },
    /** 퇴근 */
    OFF: {
        type: 'off',
        code: 'OFF',
        text: 'common.off',
        color: '',
        textColor: '#d32f2f',
        textColorClass: 'text-red-darken-2',
    },
    /** 대기 */
    WAITING: {
        type: 'waiting',
        code: 'WAITING',
        text: 'common.waiting',
        color: '#E1BEE7',
        textColor: '#388E3C',
        textColorClass: 'brg-color-green-700',
    },
    /** 배차 */
    ALLOCATED: {
        type: 'allocated',
        code: 'ALLOCATED',
        text: 'common.allocated',
        color: '',
        textColor: '',
    },
    /** 운행 */
    DRIVING: {
        type: 'driving',
        code: 'DRIVING',
        text: 'common.driving',
        color: '#B8E0FF',
        textColor: '#0072FF',
        textColorClass: 'brg-color-blue-700',
    },
    /** 휴식 */
    REST: {
        type: 'rest',
        code: 'REST',
        text: 'common.rest',
        color: '#CFD8DC',
        textColor: '#7B1FA2',
        textColorClass: 'text-purple-darken-2',
    },
};
/** 관제 라이더 필터 */
export const attendCodeForWorkerFilter = [
    'ON',
    'WAITING',
    'REST',
].reduce((acc, [key, value,]) => {
    acc[key] = attendCode[value];
    return acc;
}, {});
export default attendCode;
